// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__3df-V","fullScreen":"style_fullScreen__3MBsW","hidden":"style_hidden__1K96E"};